import React from 'react'
import Link from "gatsby-link"
import styled, { css } from 'styled-components'
import { rgba } from 'polished'

import { Share } from '../'

import arrowBack from '../../assets/icons/arrow-back.svg'

import { media, width, isClient } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { projectIntro } from '../../styles/type';


class Footer extends React.Component {

	state = {

	}
	
	componentWillMount = () => {

	}
		
	render() {
        const {title, pageURL, backLink, backLinkText } = this.props;
		
		return (
			<React.Fragment>

                <Container
					location={isClient() && location.pathname}
				>
                
                    <BackLink
                        to={backLink}
                    >
                        <Arrow/>
                        <Text>{backLinkText}</Text>
                    </BackLink>
                    <Share 
                        title={title}
                        url={pageURL}
                    />

                </Container>

			</React.Fragment>
		)
	}
}



const Container = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
    border-top: 1px solid rgba(0,0,0,0.08);
	padding: 10rem;
	box-sizing: border-box;

	${media.phone`
		padding: 40px;
	`}

	${props => {
		if (props.location == '/casestudy') return css`
			border-top: 0;
		`
	}}
`

const BackLink = styled(Link)`
	display: flex;
	align-items: center;
	${hoverState};
`

const Arrow = styled.div`
    background-image: url(${arrowBack});
    width: 18px;
    height: 18px;
    ${bgIcon}
    cursor: pointer;
`

const Text = styled.div`
	margin-left: 10px;
	${projectIntro};
	text-indent: 0!important;
`

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js